import React, { createContext, useState, useContext, useEffect } from "react";
import tr from "../locales/tr.json";
import en from "../locales/en.json";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

// Get saved language from localStorage or default to 'tr'
const getSavedLanguage = () => {
  try {
    const savedLang = localStorage.getItem("ATIKSOFT-language");
    return savedLang === "en" || savedLang === "tr" ? savedLang : "tr";
  } catch (error) {
    return "tr";
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getSavedLanguage);

  const translations = {
    tr,
    en,
  };

  const t = (key) => {
    const keys = key.split(".");
    let value = translations[language];

    for (const k of keys) {
      value = value?.[k];
    }

    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => {
      const newLang = prev === "tr" ? "en" : "tr";
      // Save to localStorage
      try {
        localStorage.setItem("ATIKSOFT-language", newLang);
      } catch (error) {
        console.error("Failed to save language preference:", error);
      }
      return newLang;
    });
  };

  // Update localStorage when language changes (backup)
  useEffect(() => {
    try {
      localStorage.setItem("ATIKSOFT-language", language);
    } catch (error) {
      console.error("Failed to save language preference:", error);
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
